import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import LoadingButton from '../LoadingButton.jsx';

function NextButton({
  isLoading, onNext, disabled, label,
}) {
  const { t } = useTranslation('activation_wizard');

  return (
    <LoadingButton
      className="nextButton"
      isLoading={isLoading}
      onClick={(onNext) ? () => onNext() : undefined}
      disabled={disabled}>
    {label || t('next_button_label')}
    </LoadingButton>
  );
}

function BackButton({ onBack }) {
  const { t } = useTranslation('activation_wizard');

  return (
    <button
      type="button"
      className="backButton"
      onClick={() => onBack()}>
      &lt; {t('back_button_label')}
    </button>
  );
}

function SkipButton() {
  return (
    <button>Skip</button>
  );
}

function NavBar({
  onNext, nextLabel, nextDisabled, onBack, onSkip, isLoading,
}) {
  return (
    <div className="NavBar">
      <NextButton
        label={nextLabel}
        onNext={onNext}
        isLoading={isLoading}
        disabled={nextDisabled}
      />

      {onSkip ? (
        <SkipButton />
      ) : null}

      {onBack ? (
        <BackButton onBack={onBack}/>
      ) : null}
    </div>
  );
}

NavBar.propTypes = {
  onNext: PropTypes.func,
  nextLabel: PropTypes.string,
  onBack: PropTypes.func,
  isLoading: PropTypes.bool,
  nextDisabled: PropTypes.bool,
};

export default NavBar;
